import React from "react";
import SectionWrapper from "components/layout/section_wrapper";


export default function MapSection({ property }) {


  return (
    <SectionWrapper theme="dark" padded={false}>
      {/* <Col xs="12">
        <div className={styles.contactsSection}>
          <Map location={location} />
        </div>
      </Col> */}
    </SectionWrapper>
  );
}
